export const currentBrand = process.env.REACT_APP_WEBSITE_BRAND || 'vwfs';
export const integrationApiBaseUrl = process.env.REACT_APP_INTEGRATION_API_BASE_URL;
export const integrationApiBaseUrlLocal = process.env.REACT_APP_API_BASE_URL_LOCAL;
export const headlessCmsVersion = process.env.REAC_APP_HEADLESS_CMS_VERSION || 'v1';
export const fesApiBaseUrl = process.env.REACT_APP_FES_API_BASE_URL;
export const apiGatewayConsumerName = 'vwfs-du-cpfr';
export const maxFileSize = 4 * 1024 * 1024;
export const reducedMaxFileSize = 2 * 1024 * 1024;
export const idpHint = process.env.REACT_APP_IDP_HINT;
export const pbpLoginUrl = process.env.REACT_APP_AUTH_PROVIDER_URL;
export const payByPhoneEnabled = false;
export const bronsonTheme = process.env.REACT_APP_WEBSITE_BRONSON_THEME || 'bluelabel';
// Without a timeout axios waits forever, so a hung call leaves the user on a
// spinner with no error path - which is what makes them resubmit the request.
export const apiRequestTimeout = 60 * 1000;
// Requests carrying base64 encoded documents need a lot more headroom on a
// mobile connection, so they pass this timeout explicitly.
export const apiUploadTimeout = 5 * 60 * 1000;
